import { AppStateProvider, usePage } from '@bees-web/core/shared/contexts'
import { VSConfiguration } from '@bees-web/core/types'
import { FC, useEffect } from 'react'

import { useGlobalFeatureFlags, useInitializeUser, useWorkspace } from '../hooks'

import Block from './BlockOptimized'

export interface PageContentProps {
  workspace: VSConfiguration
  dependencies?: VSConfiguration[]
}

const PageContent: FC<PageContentProps> = ({ workspace, dependencies }) => {
  const {
    setInteractiveMap,
    page: { template },
  } = usePage()

  useGlobalFeatureFlags()

  const { interactiveMap: processedInteractiveMap, workspaceState } = useWorkspace(
    workspace,
    dependencies
  )

  useEffect(() => {
    setInteractiveMap(processedInteractiveMap)
  }, [processedInteractiveMap, setInteractiveMap])

  useInitializeUser()

  return (
    <AppStateProvider state={workspaceState}>
      {template.data.blocks?.map((block) => (
        <Block key={block.name} template={block} />
      ))}
    </AppStateProvider>
  )
}

export default PageContent
